export default __webpack_public_path__ + "static/media/Libuše_BedřichSmetana.11bccc70.mp4";